import React from 'react';
import { GiftIcon, InfoIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { bonuses } from '../../data/bonuses';
export function BonusesSection() {
  return <section className="bg-cream-deep px-5 py-20 md:py-28" data-id="element-68" data-mp="qd8zs2o1hxeq">
      <div className="mx-auto max-w-5xl" data-id="element-69" data-mp="qetvhvm3bme6">
        <SectionHeading title={<>Y además recibís <span className="text-rose-dark" data-id="element-71" data-mp="vcc39iodfvkl">4 bonos prácticos.</span></>} data-id="element-70" data-mp="vbaiunlgtwq7" />

        <ul className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-72" data-mp="1j2fwqx7uiexv">
          {bonuses.map(b => <li key={b.label} className="flex flex-col rounded-2xl border border-line bg-white p-7 md:p-8" data-id="element-73" data-mp="1o10yj12qx6of">
              <div className="flex items-center gap-2.5" data-id="element-74" data-mp="19cd6v5w0th3r">
                <GiftIcon className="h-5 w-5 text-honey-dark" aria-hidden="true" data-id="element-75" data-mp="199r038gyf5ml" />
                <p className="text-sm font-bold uppercase tracking-widest text-honey-dark" data-id="element-76" data-mp="1e8v9o07sj5dg">{b.label}</p>
              </div>
              <h3 className="mt-3 font-serif text-xl uppercase leading-snug text-ink md:text-2xl" data-id="element-77" data-mp="21yfvcqvbwgqf">{b.title}</h3>
              <p className="mt-3 text-base font-semibold text-ink" data-id="element-78" data-mp="2m58z3qvinoil">{b.tagline}</p>
              <p className="mt-2 text-base leading-relaxed text-ink-muted" data-id="element-79" data-mp="2m35x08h3a4xi">{b.body}</p>
              {b.note && <p className="mt-3 flex items-start gap-2 text-sm italic text-ink-muted" data-id="element-80" data-mp="2h4kw06u0jh80">
                  <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose-dark" aria-hidden="true" data-id="element-81" data-mp="2vxeqaydy21wq" />
                  {b.note}
                </p>}
              <p className="mt-auto pt-5" data-id="element-82" data-mp="34v7603nkvbkn">
                <span className="block border-t border-line pt-4 text-xs font-bold uppercase tracking-wider text-sage-dark md:text-sm" data-id="element-83" data-mp="34u5jn31432nm">
                  {b.highlight}
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}